"use strict";

const RoutineInspectionRouteFactory = require("./routineInspectionRouteFactory");

const PipeRoutes = function () {
  const inspectionRoute = RoutineInspectionRouteFactory.createRoute({
    resourceKey: "pipeRoutineMaintenance",
    assetType: "pipe",
  });

  return { inspectionRoute };
};

module.exports = PipeRoutes();
